import { Directive, HostListener, Input, ElementRef } from '@angular/core';
import * as XLSX from '../../xlsx';
import { FileSaverService } from 'ngx-filesaver';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
@Directive({
    selector: '[appExcelConverter],appExcelConverter',
    standalone: false
})
export class ExcelConverterDirective {
  @Input() data: ElementRef;
  @Input() headers: string[];
  constructor(private fileSaverService: FileSaverService) { }
  @HostListener('click')
  onClick() {
    // this.tableToExcel(this.data.nativeElement, '');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(this.data);
    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = { Sheets: { 'data': ws }, SheetNames: ['data'] };
    // XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    /* save to file */
    const excelBuffer: any = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, 'STODA');

  }
  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    this.fileSaverService.save(data, fileName + '_REPORT_' + new Date().getTime() + EXCEL_EXTENSION);
  }
  
}
